"use strict";

const toggleNav = () => {
    document.querySelector('html').classList.toggle('nav-open');
};

const btnNav = document.getElementById('btn-nav');
btnNav.onclick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleNav();
}

const hideNavOnOutsideClick = (e) => {
    if (!document.querySelector('html').classList.contains('nav-open')) {
        return;
    }

    const navigation = document.getElementById('navigation');
    if (navigation.contains(e.target)) {
        return;
    }

    toggleNav();
};
document.addEventListener('click', hideNavOnOutsideClick);
